/**
 * Removes MadCap:equation, bare math, MadCap:footnote, MadCap:qrCode, and text-popup-body elements,
 * including their contents, from raw Flare topic code. Mirrors the desktop app's ExcludeFootnotesAndStuff.
 * For reference based on Formatter.ExcludeFootnotesAndStuff
 */
export function stripNonTextElements(content: string): string {
  return content
    .replace(/<MadCap:equation\b[^>]*(?:\/>|>[\s\S]*?<\/MadCap:equation>)/gi, '')
    .replace(/<math\b[^>]*(?:\/>|>[\s\S]*?<\/math>)/gi, '')
    .replace(/<MadCap:footnote\b[^>]*(?:\/>|>[\s\S]*?<\/MadCap:footnote>)/gi, '')
    .replace(/<MadCap:qrCode\b[^>]*(?:\/>|>[\s\S]*?<\/MadCap:qrCode>)/gi, '')
    .replace(/<(\w+)\b(?=[^>]*\sclass="[^"]*\bMCTextPopupBody\b[^"]*")[^>]*(?:\/>|>[\s\S]*?<\/\1>)/gi, '');
}
